import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import MatchSchedule from './components/MatchSchedule';
import QuickLinks from './components/QuickLinks';
import NewsSection from './components/NewsSection';
import PlatformReviews from './components/PlatformReviews';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { HomePageJsonLd } from './components/HomeSeoJsonLd';

export default function Home() {
  return (
    <>
      <HomePageJsonLd />
      <Navbar />
      <main>
        <HeroSection />
        <QuickLinks />
        <MatchSchedule />
        <NewsSection />
        <PlatformReviews />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}